// extracted by mini-css-extract-plugin
export default {"header":"SmallHeader_header__Mn6VA","gutter":"SmallHeader_gutter__19Jhv"};